import { action, makeObservable, observable } from 'mobx';

import { ILocalStore } from '@/stores/interfaces/ILocalStore';

type Params = {
  getVisibleIds: () => Set<string>;
};

export class SearchSelectionStore implements ILocalStore {
  private _getVisibleIds: () => Set<string>;

  readonly selectedIds = observable.set<string>();

  constructor({ getVisibleIds }: Params) {
    this._getVisibleIds = getVisibleIds;

    makeObservable(this, {
      selectedIds: observable,

      toggle: action.bound,
      clear: action.bound,
      fillVisibleAsSelected: action.bound,
    });
  }

  getItemState(id: string | number) {
    const key = String(id);

    return {
      checked: this.selectedIds.has(key),
      indeterminate: false,
    };
  }

  toggle(id: string | number): void {
    const key = String(id);

    if (this.selectedIds.has(key)) {
      this.selectedIds.delete(key);
    } else {
      this.selectedIds.add(key);
    }
  }

  fillVisibleAsSelected(): void {
    const visible = this._getVisibleIds();

    for (const id of visible) {
      this.selectedIds.add(id);
    }
  }

  clear(): void {
    this.selectedIds.clear();
  }

  toServerFormat(): string[] {
    return Array.from(this.selectedIds);
  }

  destroy(): void {
    //
  }
}
